import { useEffect, useState } from "react"
import { useExpand } from "../../hooks/useExpanded"
import { getStorage, STORAGE } from "../../utils/storage"
import { api } from "../../env"
import LoadingButton from "../../components/LoadingButton"

export const ActivityState = {
    PENDING: 0,
    COMPLETED: 1
}

export function ActivityCard({activity, onComplete}) {

    const { expanded, handleExpand } = useExpand(activity.id)
    const [loading, setLoading] = useState(false)
    const [state, setState] = useState(ActivityState.COMPLETED)
    const [isEditable, _] = useState(getStorage(STORAGE.PARTICIPANT_ROLE) == 'Mentee')

    useEffect(() => {
        setState(activity.isCompleted ? ActivityState.COMPLETED : ActivityState.PENDING)
    }, [activity])

    const getCardStyle = () => {
        if (state == ActivityState.PENDING && expanded) return "filled-primary-dark"
        if (state == ActivityState.COMPLETED) return "shaded-neutral outline-card"
    }

    const handleClick = () => {
        handleExpand(activity.id)
    }

    const handleComplete = () => {
        setLoading(true)
        api.put(`activity-instance/${activity.id}/complete`)
            .then(res => {
                setTimeout(() => setLoading(false), 50)
                onComplete(res.data)
            })
            .catch(err => {
                setLoading(false)
                console.log("Error trying to complete activity")
            })
    }

    return(
        <div className={`card clickable flex gap-m space-between center ${getCardStyle()}`} onClick={handleClick}>
            <div className="w-100">
                <p className={`card-label ${state != ActivityState.COMPLETED ? 'o-65' : 'o-50'}`}>Activity {activity.order}</p>
                <p className={`card-title ${state == ActivityState.COMPLETED ? 'regular o-50' : ''}`}>{activity.title}</p>
                {expanded && <>
                    <p className={`card-body showing dashed-border pre-wrap ${state == ActivityState.COMPLETED ? 'neutral-border' : 'o-50'} standard-padding-s vi-spacer-s`}>
                        <span className={state == ActivityState.COMPLETED ? 'o-65' : ''}>{activity.description}</span>
                    </p>
                    {isEditable && state != ActivityState.COMPLETED && <div className="flex justify-end center vi-spacer-s">
                        <LoadingButton className={'text inverted with-icon leading'} onClick={handleComplete} label={'Mark As Completed'} leadingIcon={'check'} loading={loading}/> 
                    </div>}
                </>}
            </div>
            {state == ActivityState.COMPLETED && <span className="material-symbols-outlined scale-m vi-spacer-xxs h-spacer-xs o-85">select_check_box</span>}
        </div>
    )
}